<template>
    <div class="holiday" style="height: 745px;">
        <div id="content-wrapper">
            <Button style="float: right;width: 150px;height: 40px;margin-right: 5%;margin-bottom: 10px;"  @click="holiday">上传节假日文件</Button>
            <Button style="float: right;width: 150px;height: 40px;margin-right: 10px;margin-bottom: 10px;"  @click="download">下载节假日模板文件</Button>
            <iframe id="download" src="" frameborder="0" hidden></iframe>
  <div class="inner clearfix">
      <div id='calendar'>

      </div>
    </div>
            <!--上传假期文件-->
            <Modal
                    v-model="modalHoliday"
                    height=30%
                    width=30%>
                <h1 slot="header" style="text-align: center;">上传假期文件</h1>
                <row>

                    <div>
                        <i-col span="10">
                            <div>
                                请选择年份：
                                <DatePicker type="year" :options='options2' v-model="rest_year" formate="yyyy" @on-change="setDate($event)"  style="width: 200px;margin-bottom: 20px;"></DatePicker>
                            </div>
                            <div style="width: 400px;">
                                <div>
                                    <Upload
                                            multiple
                                            ref="upload"
                                            :action='this.action'
                                            :format="['xls','xlsx']"
                                            :headers="{token:this.getKey('token')}"
                                            :data="this.holiday_year"
                                            :on-success="handleSuccess"
                                            :show-upload-list="false"
                                            style="display: inline-block;">
                                        <Button type="ghost" icon="ios-cloud-upload-outline" :disabled="disable">上传附件</Button>
                                    </Upload>
                                </div>
                            </div>
                        </i-col>



                    </div>

                </row>
                <div slot="footer">

                </div>
            </Modal>
    </div>
    </div>
</template>


<script>
    import { SimpleCalendar } from "assets/../global/rili/javascripts/simple-calendar.js"
    export default {
        data () {
          return{
              action:parameters.domain+'/manage/holiday/upload',
			modalHoliday: false,
				disable: true,
				rest_year: '',
				holiday_year: {
					year: ''
				},
				options2: { //不可选每月15号
					disabledDate(date) {
						if (date.format('yyyy') != new Date().format('yyyy') && date.format('yyyy') != parseInt(new Date().format('yyyy')) + 1 && date.format('yyyy')!=2018) {
							return date
						}
					}
				}
			}
		},
		components: {
		
			},
		methods: {//设置日期
            setDate:function (value) {
                console.log(value);
                this.holiday_year.year=value;
                this.disable=false;
            },
            //下载节假日模板文件
            download:function () {
                $("#download").attr('src',parameters.domain+"/manage/holiday/download?token="+this.getKey('token'));
                console.log($("#download").attr('src'))
            },
            holiday:function () {
                this.modalHoliday=true
            },
            //上传文件成功回调
            handleSuccess:function (res,file) {
            	this.setAddOneDay(1);
            	this.modalHoliday = false;
                this.$Message.success('上传成功');
            },
            getHolidayYear:function (n) {
                var that = this;
                var params = {};
                var holidayAll;
                params.data = {year:parseInt(new Date().format('yyyy'))};
                params.token = this.getKey('token');
                params.url = '/manage/holiday/list';
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res)
                    var obj = {};
                    holidayAll = res.data.result.result;
					for(var i = 0;i<holidayAll.length;i++){
						if (holidayAll[i].year == parseInt(new Date().format('yyyy'))) {
							obj[parseInt(holidayAll[i].date.split("-")[0])+"-"+parseInt(holidayAll[i].date.split("-")[1])] = "  ";
						}
					}
					var itit = {
						aa: obj,
						bb: n
					}
					var myCalendar = new SimpleCalendar('#calendar',{},itit);
                }
                this.ajaxPost(params);
            },
            setAddOneDay:function (n) {
                var that = this;
                var params = {};
                var holidayAll;
                params.data = {year:parseInt(new Date().format('yyyy')) + n};
                params.token = this.getKey('token');
                params.url = '/manage/holiday/list';
                params.success = function(res) {
                    that.$Loading.finish();
                    var obj = {};
                    holidayAll = res.data.result.result;
					for(var i = 0;i<holidayAll.length;i++){
						if (holidayAll[i].year == parseInt(new Date().format('yyyy')) + n) {
							obj[parseInt(holidayAll[i].date.split("-")[0])+"-"+parseInt(holidayAll[i].date.split("-")[1])] = "  ";
						}
					}
					that.getHolidayYear(obj)
                }
                this.ajaxPost(params);
            }
        },
        mounted: function() {
        	this.setAddOneDay(1)
        },
        watch: {
            'rest_year' :function () {
                var that =this;
                if(this.rest_year!=''){
                    that.disable=false
                }

            },
        },
    }
</script>

<style lang="scss">
    #calendar{
        width: 90%;
        margin: 0 auto;
        margin-left: 5%;
      }
      .sc-actions:first-child{
      	/*display: none;*/
      }
      .clearfix{
        margin-bottom: 50px !important;
      }
</style>



// WEBPACK FOOTER //
// src/components/infoMana/holiday.vue